const QUERIES = {
  USERS_LIST: 'users-list',
  REVIEW_LIST: 'review-list',
  TOKEN_LIST: 'token-list',
  TAG_LIST: 'tag-list',
  SUBJECT_LIST: 'subject-list',
}

export {QUERIES}
